<header>
  <div id="myLinks" class="myLinks">
    <div class="container">
      <div class="topnav">
        <div class="flex">
          <img src="{{logoImageMobile}}" alt="logo">
          <div class="box-tel">
            <div class='wrap-logo-tel'>
              <img src="/assets/img/phone.svg" alt="">
              <div>
                <a href="tel:+78003338837" class="phone">8 (800) 333 88 37</a>
              </div>
            </div>
            <select>
              <option *ngFor="let list of lists" value="list">{{list}}</option>
            </select>
          </div>
        </div>
        <div class="d-flex">
          <a *ngIf="flag != 'auth' && token" class="icon me-3" (click)="goToMessenger()">
            <i class="pi pi-envelope p-text-secondary profile-mg-send"
               pBadge style="font-size: 1.5rem" severity="danger"
               value="{{ unreadMessagesCountString }}"
               [ngClass]="{'hide-badge': unreadMessagesCount == 0}">
            </i>
          </a>
          <a class="icon" (click)="myFunctionClose()">
            <i class="pi" style="font-size: 1.5rem" [ngClass]="{'pi-bars': !mobMenuVisible, 'pi-times': mobMenuVisible}"></i>
<!--            <i class="pi pi-times" style="font-size: 1.5rem" *ngIf="mobMenuVisible"></i>-->
          </a>
        </div>
      </div>
      <div class="line"></div>

      <ul class="nav  nav-ul nav-menu-mob">
        <br>
        <li class="nav-item" *ngIf="flag =='user' || token">
          <div class="balance-box" *ngIf="currentUserProfile">
            <a class="nav-link pb-0" (click)="goToProfile()">Профиль</a>
            <p class="balance">Баланс {{ currentUserProfile?.balance | number:'1.2-2' }} ₽</p>
          </div>
        </li>
        <br>
        <!-- NavBar для моб устройств, показываются в случае если пользователь авторизован и на главной-->
        <li class="nav-item" *ngIf="flag == 'user' || flag == 'shared' && token">
          <a class="nav-link" [routerLink]="['/user/main']">Главная</a>
        </li>
        <li class="nav-item" *ngIf="flag == 'user' || flag == 'shared' && token">
          <a class="nav-link instagram-text-gradient" [routerLink]="['/shared/complete-orders']">instroygram</a>
        </li>
        <li class="nav-item" *ngIf="flag == 'user' || flag == 'shared' && token">
          <a class="nav-link" [routerLink]="['/user/main']">Мои заказы</a>
        </li>
        <li class="nav-item" *ngIf="flag == 'user' || flag == 'shared' && token">
          <a class="nav-link" (click)="goToCalc()">Калькулятор</a>
        </li>
        <li class="nav-item" *ngIf="flag == 'user' || flag == 'shared' && token">
          <a class="nav-link" [routerLink]="['/shared/services/']">Услуги сервиса</a>
        </li>
        <li class="nav-item" *ngIf="flag == 'user' || flag == 'shared' && token">
          <a class="nav-link" (click)="goToMessenger()">Чат</a>
        </li>
        <li class="nav-item" *ngIf="flag == 'user' || flag == 'shared' && token">
          <a class="nav-link" [routerLink]="['/user/my-homes']">Мой дом</a>
        </li>
        <li class="nav-item" *ngIf="flag == 'user' || flag == 'shared' && token">
          <br>
          <a class="nav-link" (click)="logout()">Выйти</a>
        </li>

<!--        <li class="nav-item" *ngIf="flag == 'shared' && token">-->
<!--          <a class="nav-link" [routerLink]="['/user/main']">Мои заказы</a>-->
<!--        </li>-->
<!--        <li class="nav-item" *ngIf="flag == 'shared' && token">-->
<!--          <a class="nav-link" (click)="goToCalc()">Калькулятор</a>-->
<!--        </li>-->
<!--        <li class="nav-item" *ngIf="flag == 'shared' && token">-->
<!--          <a class="nav-link" [routerLink]="['/shared/complete-orders/']">Наши работы</a>-->
<!--        </li>-->
<!--        <li class="nav-item" *ngIf="flag == 'shared' && token">-->
<!--          <a class="nav-link" (click)="goToProfile()">Профиль</a>-->
<!--        </li>-->
<!--        <li class="nav-item" *ngIf="flag == 'shared' && token">-->
<!--          <a class="nav-link" (click)="goTo()">Архив</a>-->
<!--        </li>-->

<!--        <li class="nav-item" *ngIf="flag == 'shared' && token">-->
<!--          <br>-->
<!--          <a class="nav-link" (click)="logout()">Выйти</a>-->
<!--        </li>-->

        <!-- Показывается для не авторизованного пользователя на лендинге-->
        <li class="nav-item" *ngIf="flag == 'landing' || flag == 'shared' && !token">
          <a class="nav-link" href="/landing#aboutus">О нас</a>
        </li>
        <li class="nav-item" *ngIf="flag == 'landing' || flag == 'shared' && !token">
          <a class="nav-link" href="/landing#services">Услуги</a>
        </li>
        <li class="nav-item" *ngIf="flag == 'landing' || flag == 'shared' && !token">
          <a class="nav-link" href="/landing#projects">Проекты</a>
        </li>
        <li class="nav-item" *ngIf="flag == 'landing' || flag == 'shared' && !token">
          <a class="nav-link" (click)="goToCalc()">Калькулятор</a>
        </li>
        <li class="nav-item" *ngIf="flag == 'landing' || flag == 'shared' && !token">
          <a class="nav-link" href="/landing#contacts">Контакты</a>
        </li>
        <li class="nav-item" *ngIf="flag =='landing' && token">
          <a class="nav-link" (click)="goToProfile()" *ngIf="token">Профиль</a>
        </li>
        <li class="nav-item wrap-link-mob" *ngIf="flag == 'landing' || flag == 'shared' && !token">
          <a class="nav-link" (click)="goToAutorization()" *ngIf="!token">Авторизация</a>
          <p-menu #menu [model]="itemsLand" [popup]="true"></p-menu>
          <a class="nav-link" (click)="goToMain()" *ngIf="token">Главная</a>
        </li>

        <li class="nav-item" *ngIf="flag == 'landing'">
          <br>
          <a class="nav-link" (click)="logout()" *ngIf="token">Выйти</a>
        </li>
      </ul>

    </div>
  </div>
  <div class="container">
    <div class="wrap-full-content">
      <div class="container-wrap">
        <div class="wrap-nav">
          <div class="topnav">
            <div class="flex">
              <img src="{{logoImageMobile}}">
              <div class="box-tel">
                <div class='wrap-logo-tel'>
                  <img src="/assets/img/phone.svg">
                  <div>
                    <a href="tel:+78003338837" class="phone">8 (800) 333 88 37</a>
                  </div>
                </div>
                <select>
                  <!-- <option selected value="lists[0]">{{ lists[0] }}</option> -->
                  <option *ngFor="let list of lists" value="list">{{list}}</option>
                </select>
              </div>
            </div>
            <div class="d-flex">
              <a *ngIf="flag != 'auth' && token" class="icon me-3" (click)="goToMessenger()">
                <i class="pi pi-envelope p-text-secondary profile-mg-send"
                   pBadge style="font-size: 1.5rem" severity="danger"
                   value="{{ unreadMessagesCountString }}"
                   [ngClass]="{'hide-badge': unreadMessagesCount == 0}">
                </i>
              </a>
              <a *ngIf="flag != 'auth'" class="icon" (click)="myFunctionOpen()">
                <i class="pi pi-bars" style="font-size: 1.5rem"></i>
              </a>
            </div>
          </div>
          <div class="menu-web">
            <div class='wrap-logo-web'>
              <div>
                <img class='cursor' src="{{logoImage}}" routerLink="/user/main" alt="">
              </div>
              <div class="box-tel-web">
                <div class='wrap-logo-tel-web'>
                  <img src="/assets/img/phone.svg" alt="">
                  <a href="tel:+78003338837">8 (800) 333 88 37</a>
                </div>
                <select class="select-web d-none">
                  <!-- <option selected value="lists[0]">{{ lists[0] }}</option> -->
                  <option *ngFor="let list of lists" value="list">{{list}}</option>
                </select>
              </div>
            </div>
            <ul class="nav justify-content-end nav-ul">
              <li class="nav-item" *ngIf="flag =='user' || flag == 'shared' && token">
                <a class="nav-link" [routerLink]="['/user/main/']">Мои заказы</a>
              </li>
              <li class="nav-item" *ngIf="flag =='user' || flag == 'shared' && token">
                <a class="nav-link" [routerLink]="['/shared/services/']">Услуги</a>
              </li>
              <li class="nav-item" *ngIf="flag =='user' || flag == 'shared' && token">
                <a class="nav-link instagram-text-gradient" [routerLink]="['/shared/complete-orders/']">instroygram</a>
              </li>
              <li class="nav-item" *ngIf="flag =='user' || flag == 'shared' && token">
                <button (click)="goToCalc()" class="btn-main">+ Создать проект</button>
              </li>
              <li class="nav-item" *ngIf="flag =='user' || flag == 'shared' && token">
                <div class="balance-box" *ngIf="currentUserProfile">
                  <p class="balance-title">Баланс</p>
                  <p class="balance">{{ currentUserProfile?.balance | number:'1.2-2' }} ₽</p>
                </div>
              </li>
              <li class="nav-item" *ngIf="flag =='user' || flag == 'shared' && token">
                <a (click)="goToMessenger()">
                  <i class="pi pi-envelope p-text-secondary profile-mg-send"
                     pBadge
                     severity="danger"
                     value="{{ unreadMessagesCountString }}"
                     [ngClass]="{'hide-badge': unreadMessagesCount == 0}"
                     ></i>
                </a>
              </li>
              <li class="nav-item" *ngIf="flag =='user' || flag == 'shared' && token">
                <img *ngIf='currentUserProfile?.photoPath' class="profile-mg"
                     src="{{ currentUserProfile?.photoPath }}" (click)="menu.toggle($event)">
                <img *ngIf='!currentUserProfile?.photoPath' class="profile-mg"
                     src="/assets/img/User.svg" (click)="menu.toggle($event)">
                <p-menu #menu [model]="items" [popup]="true"></p-menu>
              </li>

              <li class="nav-item wrap-link" *ngIf="flag =='shared' && !token">
                <a class="nav-link" (click)="goToAutorization()" *ngIf="!token">Авторизация</a>
              </li>

              <li class="nav-item" *ngIf="flag =='landing'">
                <a class="nav-link" href="/landing#aboutus">О нас</a>
              </li>
              <li class="nav-item" *ngIf="flag =='landing'">
                <a class="nav-link" href="/landing#services">Услуги</a>
              </li>
              <li class="nav-item" *ngIf="flag =='landing'">
                <a class="nav-link" href="/landing#projects">Проекты</a>
              </li>
              <li class="nav-item" *ngIf="flag =='landing'">
                <a class="nav-link" (click)="goToCalc()">Калькулятор</a>
              </li>
              <li class="nav-item" *ngIf="flag =='landing'">
                <a class="nav-link" href="/landing#contacts">Контакты</a>
              </li>
              <li class="nav-item wrap-link" *ngIf="flag =='landing'">
                <img *ngIf='currentUserProfile?.photoPath && token' class="profile-mg"
                     src="{{ currentUserProfile?.photoPath }}" (click)="menu.toggle($event)">
                <img *ngIf='!currentUserProfile?.photoPath && token' class="profile-mg"
                     src="/assets/img/User.svg" (click)="menu.toggle($event)">
                <a class="nav-link" (click)="goToAutorization()" *ngIf="!token">Авторизация</a>
                <p-menu #menu [model]="itemsLand" [popup]="true"></p-menu>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
